<section>
  <h3 data-testid="av-check-heading-main">Camera and Audio</h3>
  <app-audio-video-check [useDefaultActions]="false">
    <app-button-container>
      <app-button
        (buttonClick)="cancelAudioVideoSelections()"
        [dataTestId]="'device-settings-cancel'"
        type="secondary"
      >
        Cancel
      </app-button>
      <app-button
        (buttonClick)="continue()"
        [dataTestId]="'device-settings-apply'"
        [isDisabled]="sharedComponentService.isContinueDisabled()"
        type="primary"
      >
        Apply Changes
      </app-button>
    </app-button-container>
  </app-audio-video-check>
</section>